import { _ } from 'utils'

/* eslint-disable no-template-curly-in-string */
export default {
    mixed: {
        required: _('form.validation.required_field', {}, false),
    },
    string: {
        email: _('form.validation.invalid_email', {}, false),
        min: ({ min }) => _('form.validation.string.min_length', { min }, false),
        max: ({ max }) => _('form.validation.string.max_length', { max }, false),
    },
    number: {
        min: ({ min }) => _('form.validation.number.min', { min }, false),
        max: ({ max }) => _('form.validation.number.max', { max }, false),
    }
}
